export default {
  "actions.confirm": "Confirm",
  settings: {
    companies: "Companies",
    clients: "Your clients",
    accountant: "Your company",
    users: "Users"
  }
};
